import { getAllContactsByIds, getAllSuppliersData, getLastEnablementDate, getLastSetteledPaymentDate, getSuppliersDataByIds, getSuppliersWithCardAcceptanceData } from "../redux/actions/vendor"
import { getContactEmailValue, getContactPhoneValue, getReadableTextForChangelog } from "./helper"
import { getListSuppliersByListId } from "../redux/actions/vendor";
import { toast } from "../components/CommonComponents/ToastComponent/toast";
import moment from "moment";
import { getPartnerById } from "../redux/actions/partner";

export const getExportListReportData = async (exportColumns, listDetails, dispatch, type = null, offset = null, limit = null) => {
    var isError = false
    var allSuppliers = []
    var allSuppliersData = []
    var allListSuppliers = []
    var allMatchedSuppliers = []

    var partnerDetail = await dispatch(getPartnerById({ partnerId: listDetails?.partnerId })).then(partnerDetail => {
        return partnerDetail
    })

    const listData = await dispatch(getListSuppliersByListId(listDetails?.id, offset, limit)).then(listSups => {
        return listSups?.listSuppliers
    })
    const allMatchedSupplierIds = listData?.filter((listSupplier) => listSupplier?.matchedSupplierId)?.map(({ matchedSupplierId }) => {
        return matchedSupplierId
    })

    const allListSupplierIds = listData?.filter((listSupplier) => listSupplier?.id)?.map(({ id }) => {
        return id
    })

    const masterSupplierIds = listData?.filter((listSupplier) => listSupplier?.supplier?.masterId)?.map((data) => {
        return data?.supplier?.masterId
    })
    const listSuppliersIds = listData?.filter((listSupplier) => listSupplier?.isInCalls)?.map(({ id }) => {
        return id
    })

    const uniqueMatchedSuppliersIds = [...new Set(allMatchedSupplierIds)]
    if (uniqueMatchedSuppliersIds && uniqueMatchedSuppliersIds?.length) {
        await dispatch(getSuppliersDataByIds(uniqueMatchedSuppliersIds)).then((res) => {
            allMatchedSuppliers = res
        }).catch(() => {
            toast.show({
                title: 'Warning',
                description: `Failed To Get Suppliers Data!`
            })
            isError = true
        })
    }
    if (allListSupplierIds && allListSupplierIds?.length) {
        await dispatch(getSuppliersDataByIds([], allListSupplierIds)).then((res) => {
            allListSuppliers = res
        }).catch(() => {
            toast.show({
                title: 'Warning',
                description: `Failed To Get Suppliers Data!`
            })
            isError = true
        })
    }
    if (allMatchedSuppliers?.length && allListSuppliers?.length) {
        const suppliers = [...allMatchedSuppliers, ...allListSuppliers]
        allSuppliersData = suppliers
    } else if (allMatchedSuppliers?.length && !allListSuppliers?.length) {
        allSuppliersData = allMatchedSuppliers
    } else if (!allMatchedSuppliers?.length && allListSuppliers?.length) {
        allSuppliersData = allListSuppliers
    }
    const getUniqueSupplierRecordsById = async (data) => {
        const uniqueMap = new Map();
        data.forEach(item => {
            uniqueMap.set(item.id, item);
        });
        return Array.from(uniqueMap.values());
    };

    if (allSuppliersData && allSuppliersData?.length) {
        allSuppliers = await getUniqueSupplierRecordsById(allSuppliersData)
    }

    if (isError) {
        toast.show({
            title: 'Warning',
            description: `Failed To get list export data!`
        })
        return []
    } else {
        let lastSettledPayments = []
        let lastEnablementDates = []
        const matchedColumns = ['matchedMasterSupplierId', 'matchedMasterSupplierName', 'matchedVendorId', 'matchedVendor', 'matchedAddress1', 'matchedAddress2', 'matchedCity', 'matchedState', 'matchedZip', 'matchedPhone', 'matchedEmail', 'matchedGenericUrl', 'matchedFullAddress'];
        const cardAccColumns = ['acceptanceInformation', 'isAcceptAmericanExpress', 'isAcceptMasterCard', 'isAcceptVisa', 'isAcceptGlobalAcceptance', 'cardPaymentByPhoneValue', 'cardPaymentByFaxValue', 'remitEmail', 'remitWeb', 'remitWebUrl', 'isAcceptPointOfSalePortal', 'cardable', 'IVR', 'cardAcceptanceNotes', 'allremitEmail'];
        const matchedSuppliersIds = listData?.length ? listData?.filter(sup => sup?.matchedSupplierId).map(({ matchedSupplierId }) => {
            let supplier = allSuppliers?.find((sup) => sup?.id === matchedSupplierId)
            matchedSupplierId = (supplier?.isMaster || (!supplier?.isMaster && !supplier?.masterId)) ? supplier?.id : supplier?.masterId;
            return matchedSupplierId;
        })?.filter(Boolean) : [];

        const uniqueMatchedSupplierIds = matchedSuppliersIds?.filter((item, index) => matchedSuppliersIds?.indexOf(item) === index)
        const batches = getPayloadBatchesToGetCardAcceptance(uniqueMatchedSupplierIds, listSuppliersIds, masterSupplierIds, 500);
        const suppliersCardData = [];
        for (let i = 0; i < batches.length; i++) {
            const { matched, list, master } = batches[i];
            try {
                const response = await dispatch(getSuppliersWithCardAcceptanceData(matched, list, master))
                suppliersCardData.push(...response);
            } catch (err) {
                console.error(`Batch ${i + 1} failed:`, err?.message)
            }
        }

        // get all last settled payments data
        if (matchedSuppliersIds && matchedSuppliersIds?.length > 0) {
            lastSettledPayments = await dispatch(getLastSetteledPaymentDate({ masterIds: matchedSuppliersIds }))
            lastEnablementDates = await dispatch(getLastEnablementDate({ masterIds: matchedSuppliersIds }))
        }

        const exportData = [exportColumns.map(column => {
            return column.label;
        })]
        const phones = allSuppliers?.map(data => data?.phone && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.phone) && !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.phone) && !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.phone) && /^\d+$/.test(data?.phone)) ? data?.phone : null)
        const emails = allSuppliers?.map(data => data?.email && /^\d+$/.test(data?.email) ? data?.email : null)
        const listPhones = suppliersCardData?.map(data => data?.phone && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.phone) && !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.phone) && !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.phone) && /^\d+$/.test(data?.phone)) ? data?.phone : null)
        const listEmails = suppliersCardData?.map(data => data?.email && /^\d+$/.test(data?.email) ? data?.email : null)
        const cardPhones = suppliersCardData?.map(data => data?.cardAcceptance?.[0]?.cardPaymentByPhoneValue && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.cardAcceptance?.[0]?.cardPaymentByPhoneValue) && !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.cardAcceptance?.[0]?.cardPaymentByPhoneValue) && !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.cardAcceptance?.[0]?.cardPaymentByPhoneValue) && /^\d+$/.test(data?.cardAcceptance?.[0]?.cardPaymentByPhoneValue)) ? data?.cardAcceptance?.[0]?.cardPaymentByPhoneValue : null)
        const cardIvrPhones = suppliersCardData?.map(data => data?.cardAcceptance?.[0]?.cardPaymentIVRPhone && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.cardAcceptance?.[0]?.cardPaymentIVRPhone) && !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.cardAcceptance?.[0]?.cardPaymentIVRPhone) && !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.cardAcceptance?.[0]?.cardPaymentIVRPhone) && /^\d+$/.test(data?.cardAcceptance?.[0]?.cardPaymentIVRPhone)) ? data?.cardAcceptance?.[0]?.cardPaymentIVRPhone : null)

        const achEmails = suppliersCardData?.map(data => data?.payment?.[0]?.emailAch && /^\d+$/.test(data?.payment?.[0]?.emailAch) ? data?.payment?.[0]?.emailAch : null)
        // const cardEmails = suppliersCardData?.map(data => data?.cardAcceptanceEmails?.[0]?.email && /^\d+$/.test(data?.cardAcceptanceEmails?.[0]?.email) ? data?.cardAcceptanceEmails?.[0]?.email : null)
        const cardEmails = suppliersCardData?.flatMap(data =>
            data?.cardAcceptanceEmails?.filter(emailObj =>
                /^\d+$/.test(emailObj?.email)
            ).map(emailObj => emailObj.email)
        ) || [];

        let contactIds = []
        let contacts = []
        let allContactIds = contactIds.concat(phones, emails, listPhones, listEmails, cardPhones, cardIvrPhones, cardEmails, achEmails)
        contactIds = allContactIds?.filter(data => data && /^\d+$/.test(data))
        const uniqueContactIds = [...new Set(contactIds)]
        if (uniqueContactIds && uniqueContactIds?.length > 0) {
            contacts = await getAllContactsByIds(uniqueContactIds, dispatch)
        }

        exportData.push(...listData.map(row => {
            let supplier
            let matchedSupplierId
            let supplierCardData
            let isAcceptsCard = false
            if (row?.vendorsInCall?.[0]) {
                supplier = allSuppliers?.find((sup) => (sup?.listSupplierId === row?.id));
                matchedSupplierId = supplier?.id || null
                supplierCardData = suppliersCardData?.find((sup) => (sup?.listSupplierId === row?.id));
                if (!supplierCardData) {
                    supplier = allSuppliers?.find((sup) => (sup?.id === row?.matchedSupplierId));
                    matchedSupplierId = supplier && (supplier?.isMaster || (!supplier?.isMaster && !supplier?.masterId)) ? supplier?.id : supplier?.masterId;
                    supplierCardData = suppliersCardData?.find((sup) => (sup?.id === matchedSupplierId));
                }
            } else {
                supplier = allSuppliers?.find((sup) => (sup?.id === row?.matchedSupplierId));
                matchedSupplierId = supplier && (supplier?.isMaster || (!supplier?.isMaster && !supplier?.masterId)) ? supplier?.id : supplier?.masterId;
                supplierCardData = suppliersCardData?.find((sup) => (sup?.id === matchedSupplierId));
            }

            if (supplierCardData?.cardAcceptance?.[0]?.isAcceptAmericanExpress || supplierCardData?.cardAcceptance?.[0]?.isAcceptMasterCard || supplierCardData?.cardAcceptance?.[0]?.isAcceptVisa) {
                isAcceptsCard = true
            }
            return exportColumns.map((column) => {
                if (column.name === 'lastSettledPaymentDate') {
                    if (!matchedSupplierId) {
                        row[column.name] = ''
                    } else {
                        const lastSettledPayment = lastSettledPayments?.find((data) => parseInt(data?.masterId) === parseInt(matchedSupplierId))
                        row[column.name] = lastSettledPayment?.maxLastPayment || ''
                    }
                }
                if (column.name === 'lastEnablementDate') {
                    if (!matchedSupplierId) {
                        row[column.name] = ''
                    } else {
                        const lastEnablementDate = lastEnablementDates?.find((data) => parseInt(data?.supplierId) === parseInt(matchedSupplierId))
                        row[column.name] = lastEnablementDate?.lastEnablementDate ? moment(lastEnablementDate?.lastEnablementDate).format('YYYY-MM-DD') : ''
                    }
                }
                if (column.name === 'callingCampaignStatus') {
                    row[column.name] = row?.reasonToNotCall ? 'Did not call - ' + row?.reasonToNotCall : ''
                }
                if (column.name === 'dataSource') {
                    if (row?.vendorsInCall?.[0]?.listSupplierId) {
                        row[column.name] = 'Called'
                    } else if (row?.matchedSupplierId) {
                        row[column.name] = 'Matched'
                    } else {
                        row[column.name] = 'Not Determined'
                    }
                }
                if (column.name === 'unSuccessfulEnablementReason') {
                    if (!row?.vendorsInCallsDetails || row?.vendorsInCallsDetails?.length === 0) {
                        row[column.name] = ''
                    } else {
                        const reason = row?.vendorsInCallsDetails?.filter((reason) => (reason?.unsuccessfulEnablementReason !== null && reason?.unsuccessfulEnablementReason !== ''))
                        row[column.name] = reason?.[0]?.unsuccessfulEnablementReason || ''
                    }
                }
                if (column.name === 'portalUrl') {
                    if (isAcceptsCard && supplierCardData?.cardAcceptance?.[0]?.isAcceptCardPaymentByOnlinePortal && supplierCardData?.cardAcceptance?.[0]?.isAcceptPortal) {
                        let portalUrl = supplierCardData?.cardAcceptance?.[0]?.portalUrl || '';
                        if (portalUrl && !portalUrl.startsWith("http://") && !portalUrl.startsWith("https://")) {
                            portalUrl = "https://" + portalUrl;
                        }
                        row[column.name] = portalUrl;
                    } else {
                        row[column.name] = '';
                    }
                }
                if (column.name === 'thirdPartyPortalUrl') {// acceptscard && online check box and 3rd portal checkbox
                    if (isAcceptsCard && supplierCardData?.cardAcceptance?.[0]?.isAcceptCardPaymentByOnlinePortal && supplierCardData?.cardAcceptance?.[0]?.isAccept3rdPartyPortal) {
                        let portalUrl = supplierCardData?.cardAcceptance?.[0]?.thirdPartyPortalUrl || ''
                        if (portalUrl && !portalUrl.startsWith("http://") && !portalUrl.startsWith("https://")) {
                            portalUrl = "https://" + portalUrl;
                        }
                        row[column.name] = portalUrl;
                    } else {
                        row[column.name] = ''
                    }
                }
                if (column.name === 'isAcceptAchPayments') {
                    row[column.name] = getReadableTextForChangelog(supplierCardData?.payment?.[0]?.[column.name])
                }
                if (column.name === 'isAcceptCheckPayments') {
                    row[column.name] = getReadableTextForChangelog(supplierCardData?.payment?.[0]?.[column.name])
                }
                if (column.name === 'contactNameOld') {
                    row[column.name] = row?.supplierDetail?.[0]?.contactNameOld || 'NONE'
                }
                if (column.name === 'qaStatus' && row.hasOwnProperty('approvedByManager')) { // List Supplier QA status
                    let status = row?.['approvedByManager'] === true ? 'Approved' : row?.['approvedByManager'] === false ? 'Rejected' : 'Pending';
                    row[column.name] = status;
                }
                if (column?.name === 'masterQaStatus') { // List Supplier matched master QA status
                    let status = (supplierCardData?.isInCalls || supplierCardData?.supplierDetail?.[0]?.approvedByQA === 9) ? 'In Calls' : supplierCardData?.supplierDetail?.[0]?.approvedByQA === 8 ? 'Approved' : supplierCardData?.supplierDetail?.[0]?.approvedByQA === 7 ? 'Rejected' : 'Pending'
                    row[column.name] = status;
                }
                if (column.name === 'isMatched') {
                    row[column.name] = row?.matchedSupplierId ? 'Matched' : 'Unmatched';
                }

                if (column.name === 'isAcceptAmexVariableFee') {
                    if (isAcceptsCard && supplierCardData?.cardAcceptance?.[0]?.isAcceptAmexCardConditions) {
                        row[column.name] = getReadableTextForChangelog(supplierCardData?.cardAcceptance?.[0]?.isAcceptAmexVariableFee)
                    } else {
                        row[column.name] = ''
                    }
                }
                if (column.name === 'isAcceptVisaVariableFee') {
                    if (isAcceptsCard && supplierCardData?.cardAcceptance?.[0]?.isAcceptVisaCardConditions) {
                        row[column.name] = getReadableTextForChangelog(supplierCardData?.cardAcceptance?.[0]?.isAcceptVisaVariableFee)
                    } else {
                        row[column.name] = ''
                    }
                }
                if (column.name === 'isAcceptMasterCardVariableFee') {
                    if (isAcceptsCard && supplierCardData?.cardAcceptance?.[0]?.isAcceptMastercardCardConditions) {
                        row[column.name] = getReadableTextForChangelog(supplierCardData?.cardAcceptance?.[0]?.isAcceptMasterCardVariableFee)
                    } else {
                        row[column.name] = ''
                    }
                }
                if (column.name === "lastAcceptanceDate") {
                    if (!supplier) {
                        row[column.name] = ''
                    } else if (row?.matchedSupplierId) {
                        let sup = allSuppliers?.find((supplier) => (supplier?.id === row?.matchedSupplierId));
                        let matchedMasterSupplierId = sup && sup?.isMaster ? sup?.id : sup?.masterId;
                        let masterSupplierCardData = suppliersCardData?.find((sup) => (sup?.id === matchedMasterSupplierId));

                        if (masterSupplierCardData?.acceptanceDate) {
                            row[column.name] = masterSupplierCardData?.acceptanceDate || ''
                        } else {
                            row[column.name] = masterSupplierCardData?.supplierDetail?.[0]?.contactDate || ''
                        }
                    } else {
                        row[column.name] = ''
                    }
                }
                if (column.name === "lastCalledDate") {
                    row[column.name] = row?.vendorsInCall?.[0]?.lastCalledDate ? moment(row?.vendorsInCall?.[0]?.lastCalledDate).format('YYYY-MM-DD') : ''
                }
                if (column.name === "employerIdNumber") {
                    row[column.name] = supplierCardData?.employerIdNumber
                }
                if (column.name === "mastercardProcessingFee") {
                    if (supplierCardData?.cardAcceptance?.[0]?.isAcceptMasterCard && supplierCardData?.cardAcceptance?.[0]?.isAcceptMastercardCardConditions) {
                        let str = ''
                        let tmpMasterCardProcessingFeeType = supplierCardData?.cardAcceptance?.[0]?.mastercardProcessingFeeType ? supplierCardData?.cardAcceptance?.[0]?.mastercardProcessingFeeType : '$'
                        let tmpMasterCardProcessingFeeValue = supplierCardData?.cardAcceptance?.[0]?.mastercardProcessingFeeValue || ''

                        if (!tmpMasterCardProcessingFeeValue?.trim()) {
                            str = ''
                        } else {
                            str = `${tmpMasterCardProcessingFeeType === '$' ? tmpMasterCardProcessingFeeType : ''}${tmpMasterCardProcessingFeeValue?.replaceAll(",", '')}${tmpMasterCardProcessingFeeType === '%' ? tmpMasterCardProcessingFeeType : ''}`
                        }
                        row[column.name] = str
                    } else {
                        row[column.name] = ''
                    }
                }

                if (column.name === "masterCreditCardMinimumAndMaximumPayment") {
                    if (supplierCardData?.cardAcceptance?.[0]?.isAcceptMasterCard && supplierCardData?.cardAcceptance?.[0]?.isAcceptMastercardCardConditions) {
                        let tmpMasterCardMinPaymentFeeType = supplierCardData?.cardAcceptance?.[0]?.mastercardMinPaymentFeeType
                        let tmpMasterCardMinPaymentFeeValue = supplierCardData?.cardAcceptance?.[0]?.mastercardMinPaymentFeeValue
                        let tmpMasterCardMaxPaymentFeeType = supplierCardData?.cardAcceptance?.[0]?.mastercardMaxPaymentFeeType
                        let tmpMasterCardMaxPaymentFeeValue = supplierCardData?.cardAcceptance?.[0]?.mastercardMaxPaymentFeeValue
                        let tmpMastercardMaxPayment = supplierCardData?.cardAcceptance?.[0]?.mastercardMaxPayment
                        let tmpMastercardMinPayment = supplierCardData?.cardAcceptance?.[0]?.mastercardMinPayment

                        let str = ''
                        let minPayment = ''

                        if (tmpMasterCardMinPaymentFeeValue && tmpMastercardMinPayment) {
                            if (tmpMasterCardMinPaymentFeeType === '$') {
                                minPayment += `${tmpMasterCardMinPaymentFeeType}${tmpMasterCardMinPaymentFeeValue?.replaceAll(",", '')} Fee if Under ${tmpMasterCardMinPaymentFeeType}${tmpMastercardMinPayment?.replaceAll(",", '')}`
                            } else if (tmpMasterCardMinPaymentFeeType === "%") {
                                minPayment += `${tmpMasterCardMinPaymentFeeValue?.replaceAll(",", '')}${tmpMasterCardMinPaymentFeeType} Fee if under $${tmpMastercardMinPayment?.replaceAll(",", '')} `
                            }
                        } else if (tmpMasterCardMinPaymentFeeValue && !tmpMastercardMinPayment) {
                            if (tmpMasterCardMinPaymentFeeType === '$') {
                                minPayment += `${tmpMasterCardMinPaymentFeeType}${tmpMasterCardMinPaymentFeeValue?.replaceAll(",", '')} Fee if Under $0`
                            } else if (tmpMasterCardMinPaymentFeeType === "%") {
                                minPayment += `${tmpMasterCardMinPaymentFeeValue?.replaceAll(",", '')}${tmpMasterCardMinPaymentFeeType} Fee if under $0 `
                            }
                        } else if (!tmpMasterCardMinPaymentFeeValue && tmpMastercardMinPayment) {
                            if (tmpMasterCardMinPaymentFeeType === '$') {
                                minPayment += `${tmpMasterCardMinPaymentFeeType}0 Fee If Under ${tmpMasterCardMinPaymentFeeType}${tmpMastercardMinPayment?.replaceAll(",", '')}  `
                            } else if (tmpMasterCardMinPaymentFeeType === "%") {
                                minPayment += `0${tmpMasterCardMinPaymentFeeType} Fee If Under $${tmpMastercardMinPayment?.replaceAll(",", '')} `
                            }
                        } else if (!tmpMasterCardMinPaymentFeeValue && !tmpMastercardMinPayment) {
                            minPayment = ''
                        } else {
                            minPayment = ''
                        }

                        let maxPayment = ''

                        if (tmpMasterCardMaxPaymentFeeValue && tmpMastercardMaxPayment) {
                            if (tmpMasterCardMaxPaymentFeeType === '$') {
                                maxPayment += `${tmpMasterCardMaxPaymentFeeType}${tmpMasterCardMaxPaymentFeeValue?.replaceAll(",", '')} Fee if Over ${tmpMasterCardMaxPaymentFeeType}${tmpMastercardMaxPayment?.replaceAll(",", '')}`
                            } else if (tmpMasterCardMaxPaymentFeeType === "%") {
                                maxPayment += `${tmpMasterCardMaxPaymentFeeValue?.replaceAll(",", '')}${tmpMasterCardMaxPaymentFeeType} Fee if Over $${tmpMastercardMaxPayment?.replaceAll(",", '')} `
                            }
                        } else if (tmpMasterCardMaxPaymentFeeValue && !tmpMastercardMaxPayment) {
                            if (tmpMasterCardMaxPaymentFeeType === '$') {
                                maxPayment += `${tmpMasterCardMaxPaymentFeeType}${tmpMasterCardMaxPaymentFeeValue?.replaceAll(",", '')} Fee if Over $0`
                            } else if (tmpMasterCardMaxPaymentFeeType === "%") {
                                maxPayment += `${tmpMasterCardMaxPaymentFeeValue?.replaceAll(",", '')}${tmpMasterCardMaxPaymentFeeType} Fee if Over $0 `
                            }
                        } else if (!tmpMasterCardMaxPaymentFeeValue && tmpMastercardMaxPayment) {
                            if (tmpMasterCardMaxPaymentFeeType === '$') {
                                maxPayment += `${tmpMasterCardMaxPaymentFeeType}0 Fee If Over ${tmpMasterCardMaxPaymentFeeType}${tmpMastercardMaxPayment?.replaceAll(",", '')}  `
                            } else if (tmpMasterCardMaxPaymentFeeType === "%") {
                                maxPayment += `0${tmpMasterCardMaxPaymentFeeType} Fee If Over $${tmpMastercardMaxPayment?.replaceAll(",", '')} `
                            }
                        } else if (!tmpMasterCardMaxPaymentFeeValue && !tmpMastercardMaxPayment) {
                            maxPayment = ''
                        } else {
                            maxPayment = ''
                        }

                        if (minPayment === '' && maxPayment === '') {
                            str = ''
                        } else if (minPayment === '' && maxPayment) {
                            str = maxPayment
                        } else if (minPayment && maxPayment === '') {
                            str = minPayment
                        } else {
                            str = minPayment + ' OR ' + maxPayment
                        }

                        row[column.name] = str
                    } else {
                        row[column.name] = ''
                    }

                }

                if (column.name === "amexProcessingFeeValue") {
                    if (supplierCardData?.cardAcceptance?.[0]?.isAcceptAmericanExpress && supplierCardData?.cardAcceptance?.[0]?.isAcceptAmexCardConditions) {
                        let str = ''
                        let tmpAmexProcessingFeeType = supplierCardData?.cardAcceptance?.[0]?.amexProcessingFeeType || '$'
                        let tmpAmexProcessingFeeValue = supplierCardData?.cardAcceptance?.[0]?.amexProcessingFeeValue

                        if (!tmpAmexProcessingFeeValue?.trim()) {
                            str = ''
                        } else {
                            str = `${tmpAmexProcessingFeeType === '$' ? tmpAmexProcessingFeeType : ''}${tmpAmexProcessingFeeValue?.replaceAll(",", '')}${tmpAmexProcessingFeeType === '%' ? tmpAmexProcessingFeeType : ''}`
                        }
                        row[column.name] = str
                    } else {
                        row[column.name] = ''
                    }
                }

                if (column.name === "amexCreditCardMinimumAndMaximumPayment") {
                    if (supplierCardData?.cardAcceptance?.[0]?.isAcceptAmericanExpress && supplierCardData?.cardAcceptance?.[0]?.isAcceptAmexCardConditions) {
                        let tmpAmexMinPaymentFeeType = supplierCardData?.cardAcceptance?.[0]?.amexMinPaymentFeeType
                        let tmpAmexMinPaymentFeeValue = supplierCardData?.cardAcceptance?.[0]?.amexMinPaymentFeeValue
                        let tmpAmexMaxPaymentFeeType = supplierCardData?.cardAcceptance?.[0]?.amexMaxPaymentFeeType
                        let tmpAmexMaxPaymentFeeValue = supplierCardData?.cardAcceptance?.[0]?.amexMaxPaymentFeeValue
                        let tmpAmericanExpressMaxPayment = supplierCardData?.cardAcceptance?.[0]?.americanExpressMaxPayment
                        let tmpAmericanExpressMinPayment = supplierCardData?.cardAcceptance?.[0]?.americanExpressMinPaymnet

                        let str = ''
                        let minPayment = ''

                        if (tmpAmexMinPaymentFeeValue && tmpAmericanExpressMinPayment) {
                            if (tmpAmexMinPaymentFeeType === '$') {
                                minPayment += `${tmpAmexMinPaymentFeeType}${tmpAmexMinPaymentFeeValue?.replaceAll(",", '')} Fee if Under ${tmpAmexMinPaymentFeeType}${tmpAmericanExpressMinPayment?.replaceAll(",", '')}`
                            } else if (tmpAmexMinPaymentFeeType === "%") {
                                minPayment += `${tmpAmexMinPaymentFeeValue?.replaceAll(",", '')}${tmpAmexMinPaymentFeeType} Fee if under $${tmpAmericanExpressMinPayment?.replaceAll(",", '')} `
                            }
                        } else if (tmpAmexMinPaymentFeeValue && !tmpAmericanExpressMinPayment) {
                            if (tmpAmexMinPaymentFeeType === '$') {
                                minPayment += `${tmpAmexMinPaymentFeeType}${tmpAmexMinPaymentFeeValue?.replaceAll(",", '')} Fee if Under $0`
                            } else if (tmpAmexMinPaymentFeeType === "%") {
                                minPayment += `${tmpAmexMinPaymentFeeValue?.replaceAll(",", '')}${tmpAmexMinPaymentFeeType} Fee if under $0 `
                            }
                        } else if (!tmpAmexMinPaymentFeeValue && tmpAmericanExpressMinPayment) {
                            if (tmpAmexMinPaymentFeeType === '$') {
                                minPayment += `${tmpAmexMinPaymentFeeType}0 Fee If Under ${tmpAmexMinPaymentFeeType}${tmpAmericanExpressMinPayment?.replaceAll(",", '')}  `
                            } else if (tmpAmexMinPaymentFeeType === "%") {
                                minPayment += `0${tmpAmexMinPaymentFeeType} Fee If Under $${tmpAmericanExpressMinPayment?.replaceAll(",", '')} `
                            }
                        } else if (!tmpAmexMinPaymentFeeValue && !tmpAmericanExpressMinPayment) {
                            minPayment = ''
                        } else {
                            minPayment = ''
                        }

                        let maxPayment = ''

                        if (tmpAmexMaxPaymentFeeValue && tmpAmericanExpressMaxPayment) {
                            if (tmpAmexMaxPaymentFeeType === '$') {
                                maxPayment += `${tmpAmexMaxPaymentFeeType}${tmpAmexMaxPaymentFeeValue?.replaceAll(",", '')} Fee if Over ${tmpAmexMaxPaymentFeeType}${tmpAmericanExpressMaxPayment?.replaceAll(",", '')}`
                            } else if (tmpAmexMaxPaymentFeeType === "%") {
                                maxPayment += `${tmpAmexMaxPaymentFeeValue?.replaceAll(",", '')}${tmpAmexMaxPaymentFeeType} Fee if Over $${tmpAmericanExpressMaxPayment?.replaceAll(",", '')} `
                            }
                        } else if (tmpAmexMaxPaymentFeeValue && !tmpAmericanExpressMaxPayment) {
                            if (tmpAmexMaxPaymentFeeType === '$') {
                                maxPayment += `${tmpAmexMaxPaymentFeeType}${tmpAmexMaxPaymentFeeValue?.replaceAll(",", '')} Fee if Over $0`
                            } else if (tmpAmexMaxPaymentFeeType === "%") {
                                maxPayment += `${tmpAmexMaxPaymentFeeValue?.replaceAll(",", '')}${tmpAmexMaxPaymentFeeType} Fee if Over $0 `
                            }
                        } else if (!tmpAmexMaxPaymentFeeValue && tmpAmericanExpressMaxPayment) {
                            if (tmpAmexMaxPaymentFeeType === '$') {
                                maxPayment += `${tmpAmexMaxPaymentFeeType}0 Fee If Over ${tmpAmexMaxPaymentFeeType}${tmpAmericanExpressMaxPayment?.replaceAll(",", '')}  `
                            } else if (tmpAmexMaxPaymentFeeType === "%") {
                                maxPayment += `0${tmpAmexMaxPaymentFeeType} Fee If Over $${tmpAmericanExpressMaxPayment?.replaceAll(",", '')} `
                            }
                        } else if (!tmpAmexMaxPaymentFeeValue && !tmpAmericanExpressMaxPayment) {
                            maxPayment = ''
                        } else {
                            maxPayment = ''
                        }

                        if (minPayment === '' && maxPayment === '') {
                            str = ''
                        } else if (minPayment === '' && maxPayment) {
                            str = maxPayment
                        } else if (minPayment && maxPayment === '') {
                            str = minPayment
                        } else {
                            str = minPayment + ' OR ' + maxPayment
                        }

                        row[column.name] = str
                    } else {
                        row[column.name] = ''
                    }
                }

                if (column.name === "visaProcessingFeeValue") {
                    if (supplierCardData?.cardAcceptance?.[0]?.isAcceptVisa && supplierCardData?.cardAcceptance?.[0]?.isAcceptVisaCardConditions) {
                        let str = ''
                        let tmpVisaProcessingFeeType = supplierCardData?.cardAcceptance?.[0]?.visaProcessingFeeType || '$'
                        let tmpVisaProcessingFeeValue = supplierCardData?.cardAcceptance?.[0]?.visaProcessingFeeValue

                        if (!tmpVisaProcessingFeeValue?.trim()) {
                            str = ''
                        } else {
                            str = `${tmpVisaProcessingFeeType === '$' ? tmpVisaProcessingFeeType : ''}${tmpVisaProcessingFeeValue?.replaceAll(",", '')}${tmpVisaProcessingFeeType === '%' ? tmpVisaProcessingFeeType : ''}`
                        }
                        row[column.name] = str
                    } else {
                        row[column.name] = ''
                    }
                }

                if (column.name === "visaCreditCardMinimumAndMaximumPayment") {
                    if (supplierCardData?.cardAcceptance?.[0]?.isAcceptVisa && supplierCardData?.cardAcceptance?.[0]?.isAcceptVisaCardConditions) {
                        let tmpVisaMinPaymentFeeType = supplierCardData?.cardAcceptance?.[0]?.visaMinPaymentFeeType
                        let tmpVisaMinPaymentFeeValue = supplierCardData?.cardAcceptance?.[0]?.visaMinPaymentFeeValue
                        let tmpVisaMaxPaymentFeeType = supplierCardData?.cardAcceptance?.[0]?.visaMaxPaymentFeeType
                        let tmpVisaMaxPaymentFeeValue = supplierCardData?.cardAcceptance?.[0]?.visaMaxPaymentFeeValue
                        let tmpVisaMaxPayment = supplierCardData?.cardAcceptance?.[0]?.visaMaxPayment
                        let tmpVisaMinPayment = supplierCardData?.cardAcceptance?.[0]?.visaMinPayment

                        let str = ''
                        let minPayment = ''

                        if (tmpVisaMinPaymentFeeValue && tmpVisaMinPayment) {
                            if (tmpVisaMinPaymentFeeType === '$') {
                                minPayment += `${tmpVisaMinPaymentFeeType}${tmpVisaMinPaymentFeeValue?.replaceAll(",", '')} Fee if Under ${tmpVisaMinPaymentFeeType}${tmpVisaMinPayment?.replaceAll(",", '')}`
                            } else if (tmpVisaMinPaymentFeeType === "%") {
                                minPayment += `${tmpVisaMinPaymentFeeValue?.replaceAll(",", '')}${tmpVisaMinPaymentFeeType} Fee if under $${tmpVisaMinPayment?.replaceAll(",", '')} `
                            }
                        } else if (tmpVisaMinPaymentFeeValue && !tmpVisaMinPayment) {
                            if (tmpVisaMinPaymentFeeType === '$') {
                                minPayment += `${tmpVisaMinPaymentFeeType}${tmpVisaMinPaymentFeeValue?.replaceAll(",", '')} Fee if Under $0`
                            } else if (tmpVisaMinPaymentFeeType === "%") {
                                minPayment += `${tmpVisaMinPaymentFeeValue?.replaceAll(",", '')}${tmpVisaMinPaymentFeeType} Fee if under $0 `
                            }
                        } else if (!tmpVisaMinPaymentFeeValue && tmpVisaMinPayment) {
                            if (tmpVisaMinPaymentFeeType === '$') {
                                minPayment += `${tmpVisaMinPaymentFeeType}0 Fee If Under ${tmpVisaMinPaymentFeeType}${tmpVisaMinPayment?.replaceAll(",", '')}  `
                            } else if (tmpVisaMinPaymentFeeType === "%") {
                                minPayment += `0${tmpVisaMinPaymentFeeType} Fee If Under $${tmpVisaMinPayment?.replaceAll(",", '')} `
                            }
                        } else if (!tmpVisaMinPaymentFeeValue && !tmpVisaMinPayment) {
                            minPayment = ''
                        } else {
                            minPayment = ''
                        }

                        let maxPayment = ''

                        if (tmpVisaMaxPaymentFeeValue && tmpVisaMaxPayment) {
                            if (tmpVisaMaxPaymentFeeType === '$') {
                                maxPayment += `${tmpVisaMaxPaymentFeeType}${tmpVisaMaxPaymentFeeValue?.replaceAll(",", '')} Fee if Over ${tmpVisaMaxPaymentFeeType}${tmpVisaMaxPayment?.replaceAll(",", '')}`
                            } else if (tmpVisaMaxPaymentFeeType === "%") {
                                maxPayment += `${tmpVisaMaxPaymentFeeValue?.replaceAll(",", '')}${tmpVisaMaxPaymentFeeType} Fee if Over $${tmpVisaMaxPayment?.replaceAll(",", '')} `
                            }
                        } else if (tmpVisaMaxPaymentFeeValue && !tmpVisaMaxPayment) {
                            if (tmpVisaMaxPaymentFeeType === '$') {
                                maxPayment += `${tmpVisaMaxPaymentFeeType}${tmpVisaMaxPaymentFeeValue?.replaceAll(",", '')} Fee if Over $0`
                            } else if (tmpVisaMaxPaymentFeeType === "%") {
                                maxPayment += `${tmpVisaMaxPaymentFeeValue?.replaceAll(",", '')}${tmpVisaMaxPaymentFeeType} Fee if Over $0 `
                            }
                        } else if (!tmpVisaMaxPaymentFeeValue && tmpVisaMaxPayment) {
                            if (tmpVisaMaxPaymentFeeType === '$') {
                                maxPayment += `${tmpVisaMaxPaymentFeeType}0 Fee If Over ${tmpVisaMaxPaymentFeeType}${tmpVisaMaxPayment?.replaceAll(",", '')}  `
                            } else if (tmpVisaMaxPaymentFeeType === "%") {
                                maxPayment += `0${tmpVisaMaxPaymentFeeType} Fee If Over $${tmpVisaMaxPayment?.replaceAll(",", '')} `
                            }
                        } else if (!tmpVisaMaxPaymentFeeValue && !tmpVisaMaxPayment) {
                            maxPayment = ''
                        } else {
                            maxPayment = ''
                        }

                        if (minPayment === '' && maxPayment === '') {
                            str = ''
                        } else if (minPayment === '' && maxPayment) {
                            str = maxPayment
                        } else if (minPayment && maxPayment === '') {
                            str = minPayment
                        } else {
                            str = minPayment + ' OR ' + maxPayment
                        }

                        row[column.name] = str
                    } else {
                        row[column.name] = ''
                    }
                }

                if (matchedColumns.includes(column.name) || cardAccColumns.includes(column.name)) {
                    if (supplier && supplierCardData) {
                        if (matchedColumns.includes(column.name)) {
                            row[column.name] = getListMatchedVendorData(column.name, supplier, contacts, matchedSupplierId, supplierCardData)
                        } else if (cardAccColumns.includes(column.name)) {
                            if (column.name === 'remitEmail') {
                                if (isAcceptsCard && supplierCardData?.cardAcceptance?.[0]?.isAcceptCardPaymentByEmail) {
                                    row[column.name] = supplierCardData?.cardAcceptanceEmails?.length === 0 ? '' : getContactEmailValue(supplierCardData?.cardAcceptanceEmails?.[0]?.email, contacts)
                                } else {
                                    row[column.name] = '';
                                }
                            }
                            else if (column.name === 'allremitEmail') {
                                if (isAcceptsCard && supplierCardData?.cardAcceptance?.[0]?.isAcceptCardPaymentByEmail) {
                                    const paymentEmails = [];
                                    const remittanceEmails = [];
                                    if (supplierCardData?.cardAcceptanceEmails?.length > 0) {
                                        for (let i = 0; i < supplierCardData?.cardAcceptanceEmails?.length; i++) {
                                            const item = supplierCardData?.cardAcceptanceEmails?.[i];
                                            const emailValue = getContactEmailValue(item?.email, contacts);

                                            if (item?.emailType?.toLowerCase() === "payment") {
                                                paymentEmails.push(emailValue);
                                            } else if (item?.emailType?.toLowerCase() === "remittance") {
                                                remittanceEmails.push(emailValue);
                                            }
                                        }
                                    }

                                    let finalString = '';
                                    if (paymentEmails?.length) {
                                        finalString += `Payment: ${paymentEmails.join(", ")}`;
                                    }
                                    if (remittanceEmails?.length) {
                                        if (finalString) finalString += "; ";
                                        finalString += `Remittance: ${remittanceEmails.join(", ")}`;
                                    }
                                    row[column.name] = `"${finalString}"`;
                                } else {
                                    row[column.name] = '';
                                }
                            } else {
                                row[column.name] = getListReportColumnData(column?.name, supplierCardData?.cardAcceptance?.[0], supplierCardData?.supplierDetail?.[0]?.spend, contacts, row, isAcceptsCard, supplierCardData?.cardAcceptanceEmails, partnerDetail);
                            }
                        }
                    } else {
                        row[column.name] = '';
                    }
                }

                if (column.name === 'phone') {
                    row[column.name] = getContactPhoneValue(row?.phone, contacts)
                }

                if (column.name === 'email') {
                    row[column.name] = getContactEmailValue(row?.email, contacts)
                }
                if (column.name === 'QaTime') {
                    row[column.name] = row.QaTime ? moment(row?.QaTime).format('YYYY-MM-DD HH:mm:ss') : ''
                }

                if (column.name === 'fullAddress') {
                    row[column.name] = getFullAddress(row?.address1, row?.address2, row?.city, row?.state, row?.zip, row?.country)
                }

                if (column.name === 'paymentCount') {
                    row[column.name] = supplierCardData?.supplierDetail?.[0]?.paymentCount
                }

                if (column.name === 'currentPaymentMethod') {
                    row[column.name] = supplierCardData?.payment?.[0]?.currentPaymentMethod
                }

                if (column.name === 'checkPaymentAddress') {
                    if (supplierCardData?.payment?.[0]?.isAcceptCheckPayments) {
                        if (supplierCardData?.payment?.[0]?.isAcceptPaymentAddressFromCompanyAddress) {
                            row[column.name] = getFullAddress(supplierCardData?.payment?.[0]?.checkAddress1, supplierCardData?.payment?.[0]?.checkAddress2, supplierCardData?.payment?.[0]?.checkCity, supplierCardData?.payment?.[0]?.checkState, supplierCardData?.payment?.[0]?.checkZip, supplierCardData?.payment?.[0]?.checkCountry)
                        } else {
                            row[column.name] = getFullAddress(supplierCardData?.address1, supplierCardData?.address2, supplierCardData?.city, supplierCardData?.state, supplierCardData?.zip, supplierCardData?.country)
                        }
                    } else {
                        row[column.name] = ''
                    }
                }

                if (column.name === 'achRemitEmail') {
                    if (supplierCardData?.payment?.[0]?.isAcceptAchPayments && supplierCardData?.payment?.[0]?.emailAch) {
                        row[column.name] = getContactEmailValue(supplierCardData?.payment?.[0]?.emailAch, contacts) || ''
                    } else {
                        row[column.name] = ''
                    }
                }

                if (column.name === 'matchQaStatus') { // List Supplier QA status
                    if (row?.approvedByManager) {
                        row[column.name] = 'Approved'
                    } else if (row?.approvedByManager === false) {
                        row[column.name] = 'Rejected'
                    } else {
                        row[column.name] = 'Pending'
                    }
                }

                if (column.name === 'campaignQaStatus') { // In Calls QA Status
                    if (row?.vendorsInCall?.[0]?.status) {
                        if (row?.vendorsInCall?.[0]?.status.toLowerCase() === 'approved') {
                            row[column.name] = 'Approved'
                        } else {
                            row[column.name] = 'Pending'
                        }
                    } else {
                        row[column.name] = ''
                    }
                }

                if (column.name === 'reviewConditions') {
                    if (row?.acceptanceInformation?.toLowerCase()?.includes('accepts card review conditions')) {
                        const card = supplierCardData?.cardAcceptance?.[0];
                        if (!card) {
                            row[column.name] = '';
                        }

                        const buildFeeDetails = (
                            type, feeType, feeValue, minFeeType, minFeeValue, minPayment, maxFeeType, maxFeeValue, maxPayment
                        ) => {
                            const formatFee = (type, value) => {
                                if (!value) return '0';
                                if (type === '$') return `$${value}`;
                                if (type === '%') return `${value}%`;
                                return `$${value}`;
                            };

                            let result = `Supplier charges ${type} card processing fee of ${formatFee(feeType, feeValue)}.`;

                            if (minFeeValue || minPayment) {
                                result += ` ${formatFee(minFeeType, minFeeValue)} Fee if under $${minPayment || 0}.`;
                            }

                            if (maxFeeValue || maxPayment) {
                                result += ` ${formatFee(maxFeeType, maxFeeValue)} Fee if over $${maxPayment || 0}.`;
                            }

                            return result;
                        };

                        let details = '';
                        if (card?.isAcceptAcceptancePerCard) {
                            if (card?.isAcceptVisa && card?.isAcceptVisaCardConditions) {
                                details = buildFeeDetails(
                                    'Visa',
                                    card?.visaProcessingFeeType,
                                    card?.visaProcessingFeeValue,
                                    card?.visaMinPaymentFeeType,
                                    card?.visaMinPaymentFeeValue,
                                    card?.visaMinPayment,
                                    card?.visaMaxPaymentFeeType,
                                    card?.visaMaxPaymentFeeValue,
                                    card?.visaMaxPayment
                                );
                            } else if (card?.isAcceptMasterCard && card?.isAcceptMastercardCardConditions) {
                                details = buildFeeDetails(
                                    'MasterCard',
                                    card?.mastercardProcessingFeeType,
                                    card?.mastercardProcessingFeeValue,
                                    card?.mastercardMinPaymentFeeType,
                                    card?.mastercardMinPaymentFeeValue,
                                    card?.mastercardMinPayment,
                                    card?.mastercardMaxPaymentFeeType,
                                    card?.mastercardMaxPaymentFeeValue,
                                    card?.mastercardMaxPayment
                                );
                            } else if (card?.isAcceptAmericanExpress && card?.isAcceptAmexCardConditions) {
                                details = buildFeeDetails(
                                    'American Express',
                                    card?.amexProcessingFeeType,
                                    card?.amexProcessingFeeValue,
                                    card?.amexMinPaymentFeeType,
                                    card?.amexMinPaymentFeeValue,
                                    card?.amexMinPayment,
                                    card?.amexMaxPaymentFeeType,
                                    card?.amexMaxPaymentFeeValue,
                                    card?.americanExpressMaxPayment
                                );
                            }
                        } else {
                            if (card?.isAcceptAmericanExpress && card?.isAcceptAmexCardConditions) {
                                details = buildFeeDetails(
                                    'Generic',
                                    card?.visaProcessingFeeType,
                                    card?.visaProcessingFeeValue,
                                    card?.visaMinPaymentFeeType,
                                    card?.visaMinPaymentFeeValue,
                                    card?.visaMinPayment,
                                    card?.visaMaxPaymentFeeType,
                                    card?.visaMaxPaymentFeeValue,
                                    card?.visaMaxPayment
                                );
                            }
                        }
                        details += ' Supplier requires a card authorization form be filled out prior to first payment. Supplier accepts credit card for specific products.';
                        row[column.name] = details || '';
                    } else {
                        row[column.name] = '';
                    }
                }

                if (column.name === 'achAccountNumber' || column.name === 'achRoutingNumber') {
                    if (supplierCardData?.payment?.[0]?.isAcceptAchPayments && supplierCardData?.payment?.[0]?.isAchThroughPortal === false) {
                        if (column.name === 'achAccountNumber') {
                            row[column.name] = supplierCardData?.payment?.[0]?.bankAccountNumber || ''
                        } else if (column.name === 'achRoutingNumber') {
                            row[column.name] = supplierCardData?.payment?.[0]?.bankRoutingNumber || ''
                        }
                    } else {
                        row[column.name] = ''
                    }
                }

                if (row?.[column.name] && typeof row?.[column.name] === 'string') {
                    if (column.name === 'allremitEmail') {
                        return row?.[column.name]?.replaceAll('#', '')?.replaceAll(null, '')?.replaceAll(/\r/g, '')?.replace(/(?:\\[rn]|[\r\n])/g, " "); //?.replaceAll(',', '‚')
                    } else {
                        return row?.[column.name]?.replaceAll(',', ' ')?.replaceAll('#', '')?.replaceAll(null, '')?.replaceAll(/\r/g, '')?.replace(/(?:\\[rn]|[\r\n])/g, " ");
                    }
                } else {
                    return row?.[column.name] || '';
                }
            })
        }))
        return exportData;
    }
}

export const getListMatchedVendorData = (columnName, supplierData, contacts = [], matchedMasterSupplierId = null, masterSupplier) => {
    switch (columnName) {
        case 'matchedVendorId': // matched supplier id
            return supplierData?.id;
        case 'matchedMasterSupplierId':
            return matchedMasterSupplierId || ''; // matched supplier id's Master ID
        case 'matchedMasterSupplierName':
            return masterSupplier?.suppliername || ''; // matched supplier id's Master Suppliername
        case 'matchedVendor':
            return supplierData?.suppliername;
        case 'matchedAddress1':
            return supplierData?.address1;
        case 'matchedAddress2':
            return supplierData?.address2;
        case 'matchedCity':
            return supplierData?.city;
        case 'matchedState':
            return supplierData?.abbreviatedState ? supplierData?.abbreviatedState : supplierData?.state;
        case 'matchedZip':
            return supplierData?.zip;
        case 'matchedPhone':
            return getContactPhoneValue(supplierData?.phone, contacts)
        case 'matchedEmail':
            return getContactEmailValue(supplierData?.email, contacts)
        case 'matchedGenericUrl':
            return supplierData?.url;
        case 'matchedFullAddress':
            return supplierData?.address1 + ' ' +
                supplierData?.address2 + ' ' +
                supplierData?.city + ' ' +
                (supplierData?.abbreviatedState ? supplierData.abbreviatedState : supplierData?.state) + ' ' +
                supplierData?.zip;
        default:
            return '';
    }
}

export const getListReportColumnData = (columnName, supplierCardData, spend, contacts = [], row, isAcceptsCard, cardEmails = [], partnerDetail) => {
    var colValue = '';
    var feeData = {};
    var acceptsCard;
    if (columnName === 'acceptanceInformation' || columnName === 'cardable') {
        if (!supplierCardData || ((supplierCardData?.isAcceptAmericanExpress === null || supplierCardData?.isAcceptMasterCard === null || supplierCardData?.isAcceptVisa === null) && (supplierCardData?.isAcceptAmericanExpress !== true && supplierCardData?.isAcceptMasterCard !== true && supplierCardData?.isAcceptVisa !== true))) {
            acceptsCard = null
        } else {
            acceptsCard = (supplierCardData?.isAcceptAmericanExpress || supplierCardData?.isAcceptMasterCard || supplierCardData?.isAcceptVisa) || false;
        }
        feeData['amexProcessingFee'] = supplierCardData?.amexProcessingFeeValue ? parseFloat(supplierCardData?.amexProcessingFeeValue.replaceAll(',', '')) : supplierCardData?.amexProcessingFeeValue;
        feeData['amexMinPayment'] = supplierCardData?.americanExpressMinPaymnet ? parseFloat(supplierCardData?.americanExpressMinPaymnet.replaceAll(',', '')) : supplierCardData?.americanExpressMinPaymnet;
        feeData['amexMaxPayment'] = supplierCardData?.americanExpressMaxPayment ? parseFloat(supplierCardData?.americanExpressMaxPayment.replaceAll(',', '')) : supplierCardData?.americanExpressMaxPayment;
        feeData['amexIncrementalPayment'] = supplierCardData?.amexIncrementalPaymentAmount ? parseFloat(supplierCardData?.amexIncrementalPaymentAmount.replaceAll(',', '')) : supplierCardData?.amexIncrementalPaymentAmount;
        feeData['amexMinFeeValue'] = supplierCardData?.amexMinPaymentFeeValue ? parseFloat(supplierCardData?.amexMinPaymentFeeValue.replaceAll(',', '')) : supplierCardData?.amexMinPaymentFeeValue;
        feeData['amexMaxFeeValue'] = supplierCardData?.amexMaxPaymentFeeValue ? parseFloat(supplierCardData?.amexMaxPaymentFeeValue.replaceAll(',', '')) : supplierCardData?.amexMaxPaymentFeeValue;
        feeData['amexIncrementalFeeValue'] = supplierCardData?.amexIncrementalFeeValue ? parseFloat(supplierCardData?.amexIncrementalFeeValue.replaceAll(',', '')) : supplierCardData?.amexIncrementalFeeValue;
        feeData['visaProcessingFee'] = supplierCardData?.visaProcessingFeeValue ? parseFloat(supplierCardData?.visaProcessingFeeValue.replaceAll(',', '')) : supplierCardData?.visaProcessingFeeValue;
        feeData['visaMinPayment'] = supplierCardData?.visaMinPayment ? parseFloat(supplierCardData?.visaMinPayment.replaceAll(',', '')) : supplierCardData?.visaMinPayment;
        feeData['visaMaxPayment'] = supplierCardData?.visaMaxPayment ? parseFloat(supplierCardData?.visaMaxPayment.replaceAll(',', '')) : supplierCardData?.visaMaxPayment;
        feeData['visaIncrementalPayment'] = supplierCardData?.visaIncrementalPaymentAmount ? parseFloat(supplierCardData?.visaIncrementalPaymentAmount.replaceAll(',', '')) : supplierCardData?.visaIncrementalPaymentAmount;
        feeData['visaMinFeeValue'] = supplierCardData?.visaMinPaymentFeeValue ? parseFloat(supplierCardData?.visaMinPaymentFeeValue.replaceAll(',', '')) : supplierCardData?.visaMinPaymentFeeValue;
        feeData['visaMaxFeeValue'] = supplierCardData?.visaMaxPaymentFeeValue ? parseFloat(supplierCardData?.visaMaxPaymentFeeValue.replaceAll(',', '')) : supplierCardData?.visaMaxPaymentFeeValue;
        feeData['visaIncrementalFeeValue'] = supplierCardData?.visaIncrementalFeeValue ? parseFloat(supplierCardData?.visaIncrementalFeeValue.replaceAll(',', '')) : supplierCardData?.visaIncrementalFeeValue;
        feeData['masterProcessingFee'] = supplierCardData?.mastercardProcessingFeeValue ? parseFloat(supplierCardData?.mastercardProcessingFeeValue.replaceAll(',', '')) : supplierCardData?.mastercardProcessingFeeValue;
        feeData['masterMinPayment'] = supplierCardData?.mastercardMinPayment ? parseFloat(supplierCardData?.mastercardMinPayment.replaceAll(',', '')) : supplierCardData?.mastercardMinPayment;
        feeData['masterMaxPayment'] = supplierCardData?.mastercardMaxPayment ? parseFloat(supplierCardData?.mastercardMaxPayment.replaceAll(',', '')) : supplierCardData?.mastercardMaxPayment;
        feeData['masterIncrementalPayment'] = supplierCardData?.mastercardIncrementalPaymentAmount ? parseFloat(supplierCardData?.mastercardIncrementalPaymentAmount.replaceAll(',', '')) : supplierCardData?.mastercardIncrementalPaymentAmount;
        feeData['masterMinFeeValue'] = supplierCardData?.mastercardMinPaymentFeeValue ? parseFloat(supplierCardData?.mastercardMinPaymentFeeValue.replaceAll(',', '')) : supplierCardData?.mastercardMinPaymentFeeValue;
        feeData['masterMaxFeeValue'] = supplierCardData?.mastercardMaxPaymentFeeValue ? parseFloat(supplierCardData?.mastercardMaxPaymentFeeValue.replaceAll(',', '')) : supplierCardData?.mastercardMaxPaymentFeeValue;
        feeData['masterIncrementalFeeValue'] = supplierCardData?.mastercardIncrementalFeeValue ? parseFloat(supplierCardData?.mastercardIncrementalFeeValue.replaceAll(',', '')) : supplierCardData?.mastercardIncrementalFeeValue;
        feeData['isAcceptAmexVariableFee'] = supplierCardData?.isAcceptAmexVariableFee
        feeData['isAcceptVisaVariableFee'] = supplierCardData?.isAcceptVisaVariableFee
        feeData['isAcceptMasterCardVariableFee'] = supplierCardData?.isAcceptMasterCardVariableFee
    }
    switch (columnName) {
        case 'isAcceptAmericanExpress':
        case 'isAcceptMasterCard':
        case 'isAcceptVisa':
        case 'isAcceptGlobalAcceptance':
            return getReadableTextForChangelog(supplierCardData?.[columnName]);
        case 'cardPaymentByPhoneValue':
            if (isAcceptsCard && supplierCardData?.isAcceptCardPaymentByPhone) {
                if (supplierCardData?.isAcceptPOTSPhone) {
                    return supplierCardData?.cardPaymentByPhoneValue ? getContactPhoneValue(supplierCardData?.cardPaymentByPhoneValue, contacts) : ''
                } else if (supplierCardData?.isAcceptIVRPhone) {
                    return supplierCardData?.cardPaymentIVRPhone ? getContactPhoneValue(supplierCardData?.cardPaymentIVRPhone, contacts) : ''
                } else {
                    return ''
                }
            } else {
                return ''
            }

        case 'isAcceptCardPaymentByOnlinePortal':
            if (isAcceptsCard && supplierCardData?.isAcceptCardPaymentByOnlinePortal) {
                return getReadableTextForChangelog(supplierCardData?.isAcceptCardPaymentByOnlinePortal)
            } else {
                return 'No'
            }

        case 'cardPaymentByFaxValue':
            if (isAcceptsCard && supplierCardData?.isAcceptCardPaymentByFax) {
                return supplierCardData?.[columnName] ? supplierCardData?.[columnName] : ''
            } else {
                return ''
            }
        case 'IVR':
            if (isAcceptsCard && supplierCardData?.isAcceptIVRPhone === false) {
                return 'No';
            } else if (isAcceptsCard && supplierCardData?.isAcceptIVRPhone && supplierCardData?.cardPaymentIVRPhone) {
                return getContactPhoneValue(supplierCardData?.cardPaymentIVRPhone, contacts)
            } else {
                return '';
            }
        case 'isAcceptPointOfSalePortal':
            if (isAcceptsCard && supplierCardData?.isAcceptPointOfSalePortal) {
                return 'POS';
            } else {
                return '';
            }
        case 'acceptanceInformation':
            if (acceptsCard === null) {
                colValue = 'Unknown Card Acceptance';
            } else if (acceptsCard) {
                var isCardWithNoConditions
                var acceptsCardAutorization = (supplierCardData?.isAcceptCardAuthorizationForm && supplierCardData?.cardAuthorizationFormFile) ? true : false;
                var acceptsProductSpecification = supplierCardData?.isAcceptProductSpecific;
                if (!acceptsCardAutorization && !acceptsProductSpecification) {
                    isCardWithNoConditions = checkIsCardNoConditionsMatched(feeData, supplierCardData);
                    if (isCardWithNoConditions) {
                        colValue = 'Accepts Card no Conditions';
                    }
                }

                if (!isCardWithNoConditions) {
                    var isCardWithReviewConditions = false;
                    if (acceptsCardAutorization === true && acceptsProductSpecification === true && spend) {
                        isCardWithReviewConditions = checkIsCardFeeConditionsMatched(feeData, supplierCardData, spend, 'less', '', partnerDetail);
                    }

                    if (isCardWithReviewConditions) {
                        colValue = 'Accepts Card Review Conditions';
                    } else {
                        colValue = 'Accepts Card With Conditions';
                    }
                }
                if (colValue) {
                    var acceptsEmail, acceptsPhone, acceptsWeb, acceptsFax, acceptsEcom, acceptsInApp, acceptsPos
                    acceptsEmail = acceptsPhone = acceptsWeb = acceptsFax = acceptsEcom = acceptsInApp = acceptsPos = false
                    if (supplierCardData?.isAcceptCardPaymentByEmail && cardEmails?.length > 0) {
                        colValue += ' - Email'
                    } else if (supplierCardData?.isAcceptCardPaymentByPhone && (
                        (supplierCardData?.isAcceptPOTSPhone && supplierCardData?.cardPaymentByPhoneValue) ||
                        (supplierCardData?.isAcceptIVRPhone && supplierCardData?.cardPaymentIVRPhone)
                    )) {
                        colValue += ' - Phone'
                    } else if (supplierCardData?.isAcceptCardPaymentByOnlinePortal && (
                        (supplierCardData?.isAcceptPortal && supplierCardData?.portalUrl) ||
                        (supplierCardData?.isAccept3rdPartyPortal && supplierCardData?.thirdPartyPortalUrl)
                    )) {
                        colValue += ' - Web'
                    } else if (supplierCardData?.isAcceptCardPaymentByFax && supplierCardData?.cardPaymentByFaxValue) {
                        colValue += ' - Fax'
                    } else if (supplierCardData?.isAcceptCardPaymentByOnlinePortal && supplierCardData?.isAcceptEcommercePortal) {
                        colValue += ' - E-Commerce'
                    } else if (supplierCardData?.isAcceptCardPaymentByOnlinePortal && supplierCardData?.isAcceptInAppPortal) {
                        colValue += ' - In-App'
                    } else if (supplierCardData?.isAcceptPointOfSalePortal) {
                        colValue += ' - POS'
                    } else {
                        colValue += ' - Unknown Remittance'
                    }
                }
            } else {
                colValue = 'Does Not Accept Card';
            }
            return colValue;

        case 'cardable':
            if (acceptsCard) {
                var isCardable = checkIsCardFeeConditionsMatched(feeData, supplierCardData, spend, 'less', 'cardable', partnerDetail);
                if (isCardable) {
                    colValue = 'Yes';
                } else {
                    colValue = 'No';
                }
            } else {
                colValue = 'No';
            }
            return colValue;
        case 'cardAcceptanceNotes':
            return supplierCardData?.[columnName] ? supplierCardData?.[columnName] : ''
        default:
            return colValue;
    }
}

// check that the fee conditions matched or not
const checkCardFeeConditions = (feeValue, feeType, feeName, paymentAmount, operator = 'less', spend, partnerDetail) => {
    const rebate = partnerDetail?.partner?.rebate || 1.5
    var isConditionMatched = false;
    switch (feeName) {
        case 'processing':
        case 'min':
        case 'max':
        case 'incremental':
            if (feeType === '%') {
                isConditionMatched = feeValue ? (feeValue <= rebate ? true : false) : true;
            } else {
                if (feeName === 'processing') {
                    isConditionMatched = feeValue ? (spend ? ((feeValue / (spend / 12)) < rebate ? true : false) : false) : true;
                } else {
                    isConditionMatched = paymentAmount ? (operator === 'less' ? (feeValue <= ((paymentAmount * rebate) / 100) ? true : false) : (feeValue > ((paymentAmount * rebate) / 100) ? true : false)) : false;
                }
            }
            return isConditionMatched;
        case 'maxPayment':
            if (feeValue) {
                isConditionMatched = (operator === 'less' ? ((feeValue < (spend / 12)) ? true : false) : ((feeValue > (spend / 12)) ? true : false));
            }
            return isConditionMatched;
        default:
            return isConditionMatched;
    }
}

// To Check that the fee conditions for Card with No Conditions matched or not
const checkIsCardNoConditionsMatched = (feeData, supplierCardData) => {
    var hasProcessingFee, hasMinPayment, hasMaxPayment, hasMinFee, hasMaxFee, hasIncrementalFee, amexConditionsMatched, visaConditionsMatched, masterConditionsMatched, hasVariableFee;
    // assign default values
    hasProcessingFee = hasMinPayment = hasMaxPayment = hasMinFee = hasMaxFee = hasIncrementalFee = hasVariableFee = false;
    amexConditionsMatched = visaConditionsMatched = masterConditionsMatched = true;
    if (supplierCardData?.isAcceptAmericanExpress) {
        hasProcessingFee = feeData?.amexProcessingFee ? true : false;
        hasMinPayment = feeData?.amexMinPayment ? true : false;
        hasMaxPayment = feeData?.amexMaxPayment ? true : false;
        hasMinFee = feeData?.amexMinFeeValue ? true : false;
        hasMaxFee = feeData?.amexMaxFeeValue ? true : false;
        hasIncrementalFee = feeData?.amexIncrementalFeeValue ? true : false;
        hasVariableFee = feeData?.isAcceptAmexVariableFee ? true : false;
        amexConditionsMatched = !hasProcessingFee && !hasMinPayment && !hasMaxPayment && !hasMinFee && !hasMaxFee && !hasIncrementalFee && !hasVariableFee;
        if (!amexConditionsMatched) return false;
    }
    if (supplierCardData?.isAcceptVisa) {
        hasProcessingFee = feeData?.visaProcessingFee ? true : false;
        hasMinPayment = feeData?.visaMinPayment ? true : false;
        hasMaxPayment = feeData?.visaMaxPayment ? true : false;
        hasMinFee = feeData?.visaMinFeeValue ? true : false;
        hasMaxFee = feeData?.visaMaxFeeValue ? true : false;
        hasIncrementalFee = feeData?.visaIncrementalFeeValue ? true : false;
        hasVariableFee = feeData?.isAcceptVisaVariableFee ? true : false;
        visaConditionsMatched = !hasProcessingFee && !hasMinPayment && !hasMaxPayment && !hasMinFee && !hasMaxFee && !hasIncrementalFee && !hasVariableFee;
        if (!visaConditionsMatched) return false;
    }
    if (supplierCardData?.isAcceptMasterCard) {
        hasProcessingFee = feeData?.masterProcessingFee ? true : false;
        hasMinPayment = feeData?.masterMinPayment ? true : false;
        hasMaxPayment = feeData?.masterMaxPayment ? true : false;
        hasMinFee = feeData?.masterMinFeeValue ? true : false;
        hasMaxFee = feeData?.masterMaxFeeValue ? true : false;
        hasIncrementalFee = feeData?.masterIncrementalFeeValue ? true : false;
        hasVariableFee = feeData?.isAcceptMasterCardVariableFee ? true : false;
        masterConditionsMatched = !hasProcessingFee && !hasMinPayment && !hasMaxPayment && !hasMinFee && !hasMaxFee && !hasIncrementalFee && !hasVariableFee;
        if (!masterConditionsMatched) return false;
    }
    if (amexConditionsMatched && visaConditionsMatched && masterConditionsMatched) {
        return true;
    } else {
        return false;
    }
}

// To Check that the fee conditions for (Card with Review Conditions/Cardable) matched or not
const checkIsCardFeeConditionsMatched = (feeData, supplierCardData, spend, operator, type = 'reviewConditions', partnerDetail) => {
    var processingFeeConditionMatched, minFeeConditionMatched, maxFeeConditionMatched, incrementalFeeConditionMatched, maxPaymentConditionMatched, minPaymentConditionMatched, amexConditionsMatched, visaConditionsMatched, masterConditionsMatched, variableFeeConditionMatched;
    // assign default values
    processingFeeConditionMatched = minFeeConditionMatched = maxFeeConditionMatched = incrementalFeeConditionMatched = maxPaymentConditionMatched = minPaymentConditionMatched = variableFeeConditionMatched = false;
    amexConditionsMatched = visaConditionsMatched = masterConditionsMatched = true;

    // If accepts AMEX, Check AMEX fee Conditions
    if (supplierCardData?.isAcceptAmericanExpress) {
        processingFeeConditionMatched = feeData?.amexProcessingFee ? checkCardFeeConditions(feeData?.amexProcessingFee, supplierCardData?.amexProcessingFeeType, 'processing', '', 'less', spend, partnerDetail) : true;
        minFeeConditionMatched = feeData?.amexMinFeeValue ? checkCardFeeConditions(feeData?.amexMinFeeValue, supplierCardData?.amexMinPaymentFeeType, 'min', feeData?.amexMinPayment, operator, '', partnerDetail) : true;
        maxFeeConditionMatched = feeData?.amexMaxFeeValue ? checkCardFeeConditions(feeData?.amexMaxFeeValue, supplierCardData?.amexMaxPaymentFeeType, 'max', feeData?.amexMaxPayment, operator, '', partnerDetail) : true;
        incrementalFeeConditionMatched = feeData?.amexIncrementalFeeValue ? checkCardFeeConditions(feeData?.amexIncrementalFeeValue, supplierCardData?.amexIncrementalFeeType, 'incremental', feeData?.amexIncrementalPayment, operator, '', partnerDetail) : true;
        if (type !== 'cardable') {
            minPaymentConditionMatched = feeData?.amexMinPayment ? true : false;
            maxPaymentConditionMatched = feeData?.amexMaxPayment ? checkCardFeeConditions(feeData?.amexMaxPayment, supplierCardData?.amexMaxPaymentFeeType, 'maxPayment', feeData?.amexMaxPayment, 'greater', spend, partnerDetail) : true;
            variableFeeConditionMatched = feeData?.isAcceptAmexVariableFee === null ? false : true;
        } else {
            minPaymentConditionMatched = true;
            maxPaymentConditionMatched = true;
            variableFeeConditionMatched = true;
        }
        amexConditionsMatched = processingFeeConditionMatched && minFeeConditionMatched && maxFeeConditionMatched && incrementalFeeConditionMatched && maxPaymentConditionMatched && minPaymentConditionMatched && variableFeeConditionMatched;
        if (!amexConditionsMatched) return false;
    }
    // If accepts Visa, Check VISA fee Conditions
    if (supplierCardData?.isAcceptVisa) {
        processingFeeConditionMatched = feeData?.visaProcessingFee ? checkCardFeeConditions(feeData?.visaProcessingFee, supplierCardData?.visaProcessingFeeType, 'processing', '', 'less', spend, partnerDetail) : true;
        minFeeConditionMatched = feeData?.visaMinFeeValue ? checkCardFeeConditions(feeData?.visaMinFeeValue, supplierCardData?.visaMinPaymentFeeType, 'min', feeData?.visaMinPayment, operator, '', partnerDetail) : true;
        maxFeeConditionMatched = feeData?.visaMaxFeeValue ? checkCardFeeConditions(feeData?.visaMaxFeeValue, supplierCardData?.visaMaxPaymentFeeType, 'max', feeData?.visaMaxPayment, operator, '', partnerDetail) : true;
        incrementalFeeConditionMatched = feeData?.visaIncrementalFeeValue ? checkCardFeeConditions(feeData?.visaIncrementalFeeValue, supplierCardData?.visaIncrementalFeeType, 'incremental', feeData?.visaIncrementalPayment, operator, '', partnerDetail) : true;
        if (type !== 'cardable') {
            minPaymentConditionMatched = feeData?.visaMinPayment ? true : false;
            maxPaymentConditionMatched = feeData?.visaMaxPayment ? checkCardFeeConditions(feeData?.visaMaxPayment, supplierCardData?.visaMaxPaymentFeeType, 'maxPayment', feeData?.visaMaxPayment, 'greater', spend, partnerDetail) : true;
            variableFeeConditionMatched = feeData?.isAcceptVisaVariableFee === null ? false : true;
        } else {
            minPaymentConditionMatched = true;
            maxPaymentConditionMatched = true;
            variableFeeConditionMatched = true;
        }
        visaConditionsMatched = processingFeeConditionMatched && minFeeConditionMatched && maxFeeConditionMatched && incrementalFeeConditionMatched && maxPaymentConditionMatched && minPaymentConditionMatched && variableFeeConditionMatched;
        if (!visaConditionsMatched) return false;
    }
    // If accepts MasterCard, Check MasterCard fee Conditions
    if (supplierCardData?.isAcceptMasterCard) {
        processingFeeConditionMatched = feeData?.masterProcessingFee ? checkCardFeeConditions(feeData?.masterProcessingFee, supplierCardData?.mastercardProcessingFeeType, 'processing', '', 'less', spend, partnerDetail) : true;
        minFeeConditionMatched = feeData?.masterMinFeeValue ? checkCardFeeConditions(feeData?.masterMinFeeValue, supplierCardData?.mastercardMinPaymentFeeType, 'min', feeData?.masterMinPayment, operator, '', partnerDetail) : true;
        maxFeeConditionMatched = feeData?.masterMaxFeeValue ? checkCardFeeConditions(feeData?.masterMaxFeeValue, supplierCardData?.mastercardMaxPaymentFeeType, 'max', feeData?.masterMaxPayment, operator, '', partnerDetail) : true;
        incrementalFeeConditionMatched = feeData?.masterIncrementalFeeValue ? checkCardFeeConditions(feeData?.masterIncrementalFeeValue, supplierCardData?.mastercardIncrementalFeeType, 'incremental', feeData?.masterIncrementalPayment, operator, '', partnerDetail) : true;
        if (type !== 'cardable') {
            minPaymentConditionMatched = feeData?.masterMinPayment ? true : false;
            maxPaymentConditionMatched = feeData?.masterMaxPayment ? checkCardFeeConditions(feeData?.masterMaxPayment, supplierCardData?.mastercardMaxPaymentFeeType, 'maxPayment', feeData?.masterMaxPayment, 'greater', spend, partnerDetail) : true;
            variableFeeConditionMatched = feeData?.isAcceptMasterCardVariableFee === null ? false : true;
        } else {
            minPaymentConditionMatched = true;
            maxPaymentConditionMatched = true;
            variableFeeConditionMatched = true;
        }
        masterConditionsMatched = processingFeeConditionMatched && minFeeConditionMatched && maxFeeConditionMatched && incrementalFeeConditionMatched && maxPaymentConditionMatched && minPaymentConditionMatched && variableFeeConditionMatched;
        if (!masterConditionsMatched) return false;
    }

    if (amexConditionsMatched && visaConditionsMatched && masterConditionsMatched) {
        return true;
    } else {
        return false;
    }
}

const getFullAddress = (
    address1 = '', address2 = '', city = '',
    state = '', zip = '', country = ''
) => {
    return [address1, address2, city, state, zip, country]
        .map(part => part || ' ')
        .filter(part => part.trim())
        .join(' ');
};


function getPayloadBatchesToGetCardAcceptance(matched, list, master, batchSize) {
    const batches = [];
    let m = 0, l = 0, s = 0;

    while (m < matched?.length || l < list?.length || s < master?.length) {
        const batch = { matched: [], list: [], master: [] };
        let count = 0;

        while (m < matched?.length && count < batchSize) {
            batch.matched.push(matched[m++]);
            count++;
        }
        while (l < list?.length && count < batchSize) {
            batch.list.push(list[l++]);
            count++;
        }
        while (s < master?.length && count < batchSize) {
            batch.master.push(master[s++]);
            count++;
        }

        batches.push(batch);
    }

    return batches;
}
